import { InjectionToken } from '@angular/core';
import { AbstractBaseThemeStrategy } from '@common/libs/themes/src/strategies/abstract-base-theme.strategy';

export const THEME_CONFIG_TOKEN = new InjectionToken<string>('THEME_CONFIG_TOKEN');
export const THEME_STRATEGY_TOKEN = new InjectionToken<AbstractBaseThemeStrategy>('THEME_STRATEGY');
